import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ProgramType from "../../../containers/modules/marketing/program-type";

export default function ProgramTypeRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="program-type"
      index
      element={
        <AccessControl
          name={"Program Type List"}
          auth={authUser}
          component={() => <ProgramType />}
        />
      }
    />
  );
}
